var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"76eb8a7b807774b39d1eb91a1fd2ee6f123ab436"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.

import * as Sentry from "@sentry/nextjs";
import { Replay } from '@sentry/replay';
import { Integrations } from "@sentry/tracing";
import { commonConfig } from "./src/utils/sentry"

Sentry.init({
    ...commonConfig,

    // Session Replay sample rates (v7 style)
    replaysSessionSampleRate: 0.1,  // e.g., record 10% of sessions
    replaysOnErrorSampleRate: 1.0,  // record 100% when an error occurs

    integrations: [
        new Replay({
            maskAllText: true,
            maskAllInputs: true,
        }),
        new Integrations.BrowserTracing(),
    ],
});
